import axios from "axios";
import to from "await-to-js";

export interface IApiSymbol {
  "amount-precision": number;
  "api-trading": string;
  "base-currency": string;
  "buy-market-max-order-value": number;
  "leverage-ratio": number;
  "limit-order-max-order-amt": number;
  "limit-order-min-order-amt": number;
  "max-order-amt": number;
  "min-order-amt": number;
  "min-order-value": number;
  "price-precision": number;
  "quote-currency": string;
  "sell-market-max-order-amt": number;
  "sell-market-min-order-amt": number;
  state: string;
  "super-margin-leverage-ratio": number;
  symbol: string;
  "symbol-partition": string;
  "value-precision": number;

  name: string;
  min_amount: string;
  maker_fee_rate: string;
  taker_fee_rate: string;
  pricing_name: string;
  pricing_decimal: number;
  trading_name: string;
  trading_decimal: number;
}

export interface IApiKLine {
  id: number; //	调整为新加坡时间的时间戳，单位秒，并以此作为此K线柱的id
  amount: number; // 	以基础币种计量的交易量
  count: number; //	交易次数
  open: number; //	本阶段开盘价
  close: number; // 本阶段收盘价
  low: number; //	本阶段最低价
  high: number; //	本阶段最高价
  vol: number; //	以报价币种计量的交易量
  volume: number; //added
  time: number; //added
}

export async function fetchSymbols() {
  const [err, res] = await to(
    axios.get<{ data: { data: Record<string, IApiSymbol>[] } }>(
      "https://node.bitazar.com/market/info"
    )
  );
  if (err) return;

  return res.data?.data;
}
 
export async function fetchKLine(symbol: string, period: string, size = 500) {
  const [err, res] = await to(
    axios.get<{ data: [] }>("https://node.bitazar.com/market/kline", {
      params: { market: symbol.toUpperCase(), type: period, limit: size },
    })
  );
  const objectedData: any = [];
  if (err) return;
  //console.log(res.data?.data);
  if (res.data.data !== undefined) {
    const listData = res.data.data;

    listData.map((item) =>
      objectedData.push({
        id: +item[0],
        open: +item[1],
        close: +item[2],
        high: +item[3],
        low: +item[4],
        vol: +item[5],
      })
    );
  }
  return objectedData;
}
